<template>
    <div>
        <div>
            <div class="flex justify-between">
                <p class="sub-heding-text text-zinc-50 uppercase">DETECTION RATE</p>
            </div>
            <div class="flex items-baseline gap-1">
                <p class="number-medium-text text-zinc-50 font-medium">58/90</p>
                <p class="time-text text-tiny">% Past Hour Performance</p>
            </div>
        </div>
        <div class="w-full my-2">
            <img src="~/assets/images/soc/graph-10.png" alt="" title="" class="w-full" />
        </div>
        <div class="flex items-baseline justify-between gap-1">
            <div class="flex justify-end gap-2">
                <p class="text-cyan-500 font-semibold text-tiny">24hr</p>
                <p class="text-violet-500 font-semibold text-tiny">7d</p>
                <p class="text-[#5E66F8] font-semibold text-tiny">30d</p>
            </div>
            <p class="value-text text-tiny">90% Goal</p>
        </div>
    </div>
</template>
